import { createContext } from 'react';

export interface GitProviderSelectContextValue {
  selectedMethod: string;
  selectedProvider: string;
  setSelectedProvider: (provider: string) => void;
  isPat: boolean;
  setSelectedMethod: (provider: string) => void;
  confirmFamiliarOrgCreation: boolean;
  setConfirmFamiliarOrgCreation: (value: boolean) => void;
  onAskForInvite: () => Promise<void>;
  familiarOrgName?: string;
  email: string;
  pat: string;
  setPat: (value: string) => void;
  onConnect: () => Promise<void>;
  apiTestSuccessfully: boolean;
  tokenDisabled: boolean;
  failurePayload: unknown;
  showOrgNameField: boolean;
  orgName: string;
  setOrgName: (value: string) => void;
}

export const GitProviderSelectContext =
  createContext<GitProviderSelectContextValue>(null);
